module.exports = __webpack_public_path__ + "static/media/max_score_icon.3217c23a.JPG";